<app-layer-list-effect
  (onLayerEnabledChanged)="onLayerEnabledSubject.next($event)"
  [loading]="loadingController.changes | async"
  [distanceLabel]="translationService.getCurrentLanguage()['concentration'] || 'Concentração'"
  [allowLayerFn]="allowLayerFn"
></app-layer-list-effect>
